

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DistrictParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface DistrictMst {
    id?: number;
    name: string;
    countryId: any;
    stateId: any;
    code?:any
    district_Id?: number;
  parameters?: DistrictParameter[];
  links?: any;
}

export abstract class DistrictData {
  //abstract fireRequest(data: DistrictMst, method: string): Observable<any>;
  abstract list(): Observable<DistrictMst[]>;
  abstract create(url: string,data: DistrictMst): Observable<any>;
  abstract update(url: string,data: DistrictMst): Observable<DistrictMst>;
  abstract delete(url: string): Observable<any>;
}